if (!customElements.get('press-element')) {
  customElements.define(
    'press-element',
    class PressElement extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.testimonials = this.querySelector('.press-testimonials');
        this.thumbs = this.querySelector('.press-thumbs');
        this.sectionId = this.dataset.sectionId;
        this.testimonialsSlider = this.testimonials.querySelector('.swiper');
        this.thumbsSlider = this.thumbs.querySelector('.swiper');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
      
        window.addEventListener('resize', () => {
          this.updateGap();
          this.init(); 
        });
      
        this.updateGap();
        this.init();
      }

      init() {
        this.destroySlider();
        this.initSlider();
      }

      updateGap() {
        const columnGap = window.getComputedStyle(this.thumbs).getPropertyValue('--f-column-gap');
        this.columnGap = columnGap;
      }

      setSliderOptions() {
        const spaceBetween = parseFloat((this.columnGap || '0rem').replace('rem', '')) * 10;

        // Testimonials slider
        this.testimonialsOptions = {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          threshold: 1,
          grabCursor: true,
        };
      
        // Thumbs slider
        this.thumbsOptions = {
          slidesPerView: 'auto',
          spaceBetween: spaceBetween,
          threshold: 1,
          freeMode: true,
          centeredSlides: true,
          slideToClickedSlide: true,
          loop: true,
        };
      }

      initSlider() {
        this.setSliderOptions();
      
        // Force load images on mobile
        if (this.thumbs) {
          const lazyImages = this.thumbs.querySelectorAll('image-lazy, img[is="image-lazy"]');
          lazyImages.forEach((img) => {
            if (img.load) {
              img.load();
            } else if (img.src && !img.src.includes('data:')) {
              // Force image to load if it has a src
              const tempImg = new Image();
              tempImg.src = img.src;
            }
          });
        }
      
        const modules = [FoxTheme.Swiper.Thumbs];
      
        // Initialize thumbs slider first
        if (this.thumbsSlider) {
          this.thumbsInstance = new FoxTheme.Carousel(this.thumbsSlider, this.thumbsOptions, modules);
          this.thumbsInstance.init();
        }
      
        // Initialize testimonials slider
        if (this.testimonialsSlider) {
          if (this.thumbsInstance && this.thumbsInstance.slider) {
            this.testimonialsOptions.thumbs = {
              swiper: this.thumbsInstance.slider,
            };
          }
          
          this.sliderInstance = new FoxTheme.Carousel(this.testimonialsSlider, this.testimonialsOptions, modules);
          this.sliderInstance.init();
          
          // Add event listener only if slider is initialized
          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.on('realIndexChange', (swiper) => {
              const { realIndex, thumbs } = swiper;
              if (thumbs && thumbs.swiper) {
                thumbs.swiper.slideToLoop(realIndex);
              }
            });
          }
        }
        
        // Force update swiper after images load
        setTimeout(() => {
          if (this.thumbsInstance && this.thumbsInstance.slider) {
            this.thumbsInstance.slider.update();
          }
        }, 100);

        //shopify design mode
        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
            this.sliderInstance.slider.slideToLoop(index);
          });
        }
      }

      destroySlider() {
        if (this.sliderInstance && typeof this.sliderInstance === 'object' && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }

        if (this.thumbsInstance && typeof this.thumbsInstance === 'object' && this.thumbsInstance.slider) {
          this.thumbsInstance.slider.destroy();
          this.thumbsInstance = false;
        }
      }
    }
  );
}
